import { scribeTokens as ui } from '../../components/scribe/tokens';
import React from 'react';
import { Tabs, Tab } from '@mui/material';

export default function PatientWorkspaceTabs({ value, onChange }) {
  return <Tabs variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile value={value} onChange={onChange} sx={{ '& .MuiTab-root': { ...ui.typography.label, color: ui.colors.secondary, '&.Mui-selected': { color: ui.colors.text } }, '& .MuiTabs-indicator': { backgroundColor: ui.colors.brand } }}>
    {['dashboard', 'profile', 'consultations', 'files', 'packages'].map(tab => <Tab key={tab} data-tour={`patient-tab-${tab}`} label={tab} value={tab} />)}
  </Tabs>;
}
